import { useContext } from 'react';
import CourtContext from '../context/CourtContext';

const useCourt = () => useContext(CourtContext);

export default useCourt;
